<template>
  <!--LINE-->
  <div class="pt-1" v-if="!(lineLoggedIn&&lineAdded) &&authConfig.line && thisButtonEnabled">
    <div class="px-2" v-if="lineLoggedIn&&!lineAdded">
      <lineFriendAddButton @updateLineAddedStatus="updateLineAddedStatus" />
    </div>
    <div class="px-2" v-else-if="isAuthed">
      <line-button mode="merge">LINEを連携</line-button>
    </div>
    <div class="px-2" v-else>
      <line-button>LINEで登録</line-button>
    </div>
    <h5 class="pb-0" style="text-align: center;">
      お知らせや通知が<b>LINE</b>で届く！
    </h5>
  </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/functions'
import lineButton from '../auth/parts/lineButton.vue';
import lineFriendAddButton from "../auth/parts/lineFriendAddButton.vue";

export default {
  data() {
    return {
      thisButtonEnabled: ['kashiwanoha','ver2-test', 'jibungoto-maebashi'].includes(process.env.VUE_APP_TEMP_CITY_ID) && Number(process.env.VUE_APP_FEATURE_NOTIFY_LINE || 0),
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      lineAdded: true,
    };
  },
  mounted() {
    if (this.lineLoggedIn && this.thisButtonEnabled) {
      const checkIfLineAdded = firebase.functions().httpsCallable('checkIfUserAlreadyAddLineFriend')
      checkIfLineAdded({}).then(({data}) => {
        if (!data.isFriend) {
          this.lineAdded = data.isFriend;
        }
      })
    }
  },
  methods: {
    updateLineAddedStatus() {
      // 5秒に一回、回し続ける。 isFriendがtrueになったら終了
      const checkIfLineAdded = firebase.functions().httpsCallable('checkIfUserAlreadyAddLineFriend')
      const interval = setInterval(() => {
        console.log('checkIfLineAdded')
        checkIfLineAdded({}).then(({data}) => {
          this.lineAdded = data.isFriend;
          if (data.isFriend) {
            clearInterval(interval)
          }
        })
      }, 5000)
    },
  },
  components: {
    lineButton,
    lineFriendAddButton
},
  computed: {
    isAuthed() {
      return this.$store.state.auth.isAuthed;
    },
    lineLoggedIn() {
      return this.$store.state.auth.user.line;
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  /* flex-direction: column-reverse; */
}
</style>